import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { InputValidationService } from '../helpers/validators/input-validation.service';
import { RegExValidation } from '../helpers/constants/regex-validation.constants';
import { NgbModal, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, CurrencyPipe, PlatformLocation } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { Title } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { Guid } from 'guid-typescript';
import { UserAuthService } from '../services/user-auth.service';
import { BasicInfoService } from '../services/basic-info.service';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { HomeProgressIndicatorComponent } from '../home-progress-indicator/home-progress-indicator.component';
import { VcclogoComponent } from '../shared/vcclogo.component';
import { CurrencyMaskDirective } from '../helpers/directive/currency-mask.directive';
import { PasswordStrengthBar } from '../helpers/components/password-strength-bar';
import { FooterComponent } from '../shared/footer.component';
import { HeaderComponent } from '../shared/header.component';
import { UtilService } from '../services/util.service';
import { DEFAULT_MODAL_OPTIONS, scrollToTop } from '../shared/constants/app.constants';
import { LogoComponent } from '../logo/logo.component';
import { NeedHelpComponent } from '../shared/need-help.component';
@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  host: {'class': 'd-flex flex-column h-100 ipadfooterbottom'},
  styleUrls: ['./create-password.component.css'],
  standalone: true,
  imports: [TrackingDirective, 
    RouterLink, 
    HomeProgressIndicatorComponent, 
    VcclogoComponent, 
    CurrencyMaskDirective, 
    CurrencyPipe,
    ReactiveFormsModule,
    CommonModule,
    PasswordStrengthBar,
    NgbModule,
    FooterComponent,
    HeaderComponent,LogoComponent,NeedHelpComponent]
})
export class CreatePasswordComponent implements OnInit {
  @ViewChild('otpModel', { static: false }) otpModel: ElementRef;
  @ViewChild('captureIncomeModel', { static: false }) captureIncomeModel: ElementRef;
  @ViewChild('securityQuestionsModel', { static: false }) securityQuestionsModel: ElementRef;


  modalOptions: NgbModalOptions;

  createPasswordForm; otpForm; captureIncomeForm; captureIncomeModelRef;
  errorMsg = ''; securityQuestionErrorMsg = ''; signupSuccess = false;
  visible:boolean=true;
  changetype:boolean=true;
  visiblec:boolean=true;
  changetypec:boolean=true;
  otpErrorMsg = '';
  password = '';
  userData:'';
  captureIncomeErrorMsg = '';
  cellNumberErrorMsg = '';
  sendOtpText = 'Send SMS OTP';
  sendEmailOtpText = 'Send Email OTP';
  otpPopupHeaderText = 'Get your One-Time Pin (OTP) via SMS';
  securityQuestionList = [];
  basicInfoVerifyConfirmed: any;
  securityQuestionAttempt = 1;
  successMsg = '';
  time;
  btnOTPIsDisabled = false;
  usedOtpType;
  isOtpSent = false;
  tokenId;
  isTokenValidate = false;
  email = '';
  phoneNumber = '';
  isEmailOrPhone = false;
  isRestrictedUser: any;
  ischatbotSQConfirmed: boolean = false;
  
  constructor(
    private readonly userService: UserService,
    public readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly modalService: NgbModal,
    private readonly location: PlatformLocation,
    private readonly spinner: NgxSpinnerService,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly titleService: Title,
    private readonly userAuthService: UserAuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly basicInfoService: BasicInfoService,
    private readonly utilService: UtilService,
  ) {
    this.modalOptions = DEFAULT_MODAL_OPTIONS;
    location.onPopState(() => this.modalService.dismissAll());
    this.titleService.setTitle('Sanlam Credit Solutions registration page');
  }

  ngOnInit() {


    localStorage.removeItem('tempToken');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userPhoneNumber');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('userPhoneNumber');
    this.activatedRoute.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.tokenId = id;
      }
    });

    this.createPasswordForm = this.formBuilder.group({
      Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
      ConfirmPassword: ['', Validators.required]
    }, {
      validator: [
        InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
      ],
    });

    this.otpForm = this.formBuilder.group({
      Otp: ['', [Validators.required, Validators.minLength(4)]],
    });

    this.captureIncomeForm = this.formBuilder.group({
      GrossIncome: ['', [Validators.required, Validators.min(1)]],
    });

    this.validateToken();
    this.userAuthService.logoutActiveUser(globalThis.location.origin + '/create-password');
  }


  get createPasswordFormControls() { return this.createPasswordForm.controls; }
  get otpFormControls() { return this.otpForm.controls; }
  get captureIncomeFormControls() { return this.captureIncomeForm.controls; }

  startTimeOut() {
    globalThis.onload = () => {
      this.resetTimer();
    };

    document.onmousemove = () => {
      this.resetTimer();
    };

  }

  resetTimer() {
    if (this.time !== 'stop') {
      console.log('no Idle');
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        console.log('timeout');
        this.modalService.dismissAll();
        this.resetRegisterForm();
        this.errorMsg = 'Your session has timed-out. Please try to register again.';
      }, 5 * 60 * 1000);
  }
  }

  stopTimer() {
    clearTimeout(this.time);
    this.time = 'stop';
    console.log('Timer Stop');
    console.log(this.time);
  }

  validateToken() {
    localStorage.removeItem('tempToken');
    const param = {
      Id: this.tokenId
    };
    this.userService.validateToken(param).subscribe({
      next: (data: any)=> {
        if (data.status === 200) {
          localStorage.setItem('tempToken', data.token);
          this.isTokenValidate = true;
        }
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 500) {
          this.isTokenValidate = false;
          this.errorMsg = err.error;
        }
      }
    });

  }

  createPassword() {
    this.errorMsg = '';
    this.otpErrorMsg = '';
    this.cellNumberErrorMsg = '';
    this.securityQuestionErrorMsg = '';
    if (this.createPasswordForm.invalid) {
      this.createPasswordForm.markAllAsTouched();
      return;
    }

    this.userService.createPassword(this.createPasswordForm.value).subscribe({
      next: (data: any) => {
        if (data.status === 200) {
          if (data.responseType === 'Email') {
            this.email = data.response;
            this.isEmailOrPhone = true;
          } else {
            this.phoneNumber = data.response;
            this.isEmailOrPhone = false;
          }
          
        this.userService.fetchUserDetailsByIdNumber(data.idNumber).subscribe({
        next: (data: any) => {
        this.ischatbotSQConfirmed = data.isVerified;
        localStorage.setItem('ischatbotSQConfirmed', this.ischatbotSQConfirmed.toString());
        }
        });
          this.validateUserBasicInfoWithBureau();
  
          this.startTimeOut();
        } else {
          this.errorMsg = data.message;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.errorMsg = err.error;
      }
    });
    scrollToTop();
  }

  resetRegisterForm() {
    this.createPasswordForm.reset();
    this.createPasswordForm.markAsUntouched();
  }

  validateUserBasicInfoWithBureau() {
    this.otpErrorMsg = '';
    this.basicInfoVerifyConfirmed = false;
    this.basicInfoService.validateUserBasicInfoWithBureau().subscribe({
      next: (data: any) => {
        if (data.isVerify === true) {
          this.basicInfoVerifyConfirmed = true;
          this.isRestrictedUser=false;
        } else {
          this.basicInfoVerifyConfirmed = false;
          this.isRestrictedUser=data.isRestrictedUser;
        }
        console.log("basic info confirmed",this.basicInfoVerifyConfirmed);
        this.openOtpPage();
      },
      error: (err: HttpErrorResponse) => {
        this.openOtpPage();
      }
    });
  }

  viewpass(){
    this.visible=!this.visible;
    this.changetype=!this.changetype;
  }

  viewpassofConfirm(){
    this.visiblec=!this.visiblec;
    this.changetypec=!this.changetypec;
  }

  openOtpPage() {
    localStorage.setItem('number', this.phoneNumber);
    localStorage.setItem('verification', this.basicInfoVerifyConfirmed);
    sessionStorage.setItem('userPhoneNumber',this.phoneNumber);
    sessionStorage.setItem('userEmail',this.email);
    sessionStorage.setItem('userPhoneNumber',this.phoneNumber);
    sessionStorage.setItem('userEmail',this.email);
    this.router.navigate(['/otp']);
  }

  closeOtpPopup() {
    this.modalService.dismissAll();
    this.otpForm.reset();
    this.sendOtpText = 'Send SMS OTP';
    this.sendEmailOtpText = 'Send Email OTP';
  }

  login() {
    this.modalService.dismissAll();
    this.stopTimer();
    this.spinner.show();
    this.azureAdlogin(true);
  }

  openGrossIncomePopup() {
    this.captureIncomeModelRef = this.modalService.open(this.captureIncomeModel, this.modalOptions);
    this.captureIncomeModelRef.result.then((result: any) => {
    }, (reason: any) => {
      if (reason === 'Cross click') {
        this.openLandingPage();
      }
    });
  }


  updateIncome() {
    this.captureIncomeErrorMsg = '';
    if (this.captureIncomeForm.invalid) {
      this.captureIncomeForm.markAllAsTouched();
      return;
    }

    if (this.toNumber(this.captureIncomeForm.value.GrossIncome) >= 0) {
      this.captureIncomeForm.value.GrossIncome = parseFloat(this.toNumber(this.captureIncomeForm.value.GrossIncome));
    }


    this.userService.updateGrossIncome(this.captureIncomeForm.value).subscribe({
      next: () => { this.openLandingPage(); },
      error: (err: HttpErrorResponse) => {
        this.captureIncomeErrorMsg = err.error;
      }
    });
  }

  openDashboardPage() {
    this.modalService.dismissAll();
    this.router.navigate(['/portal/dashboard']);
  }

  openLandingPage()
  {
    this.modalService.dismissAll();
    this.router.navigate(['/portal/home']);
  }

  toNumber(val: any) {
    return this.utilService.toNumber(val);
  }

  changeGrossIncome() {
    if (this.captureIncomeForm.value.GrossIncome.toString().trim() === 'R') {
      this.captureIncomeForm.patchValue({
        GrossIncome: ''
      });
    }
  }

  azureAdlogin(isRegistrationSuccess: boolean) {
    localStorage.removeItem('tempToken');
    let submissionId = '';
    let submissionCode = Guid.create().toString();
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }

    if (isRegistrationSuccess) {
      submissionCode = '0df6b091-5d71-4f75-a6df-2d6a016e3709';
    }

    Guid.create().toString()
    this.oauthService.initLoginFlow('', {
      submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
      instrumentationKey: environment.appInsights.instrumentationKey
    });
  }

}
